// @flow
import { get } from '../../utils/fetch'

export const getLatest = async (perpage = 20, page = 1) => {
  const latest = await get(`/feed/latest?per_page=${perpage}&page=${page}`)
  if (!latest || latest.error || !Array.isArray(latest)) {
    return []
  }
  return latest.map((media) => media.type === 'sound' ? { ...media.sound, mediaType: 'sound' } : { ...media.album, mediaType: 'album' })
}

export const getFeatured = (perpage = 20, page = 1) => {
  const featured = get(`/feed/featured?perpage=${perpage}&page=${page}`)
  return featured
}
